@if (submitted()) {
  <div
    class="eventq-resolve-submit__status"
    data-testid="resolve-submit-status"
    role="status"
  >
    <mat-icon class="eventq-resolve-submit__check" aria-hidden="true">check_circle</mat-icon>
    <span class="eventq-resolve-submit__label">Submitted</span>
    @if (submittedAt()) {
      <span class="eventq-resolve-submit__time">{{ submittedAt() }}</span>
    }
  </div>
} @else {
  <button
    type="button"
    class="eventq-resolve-submit__button"
    [attr.aria-disabled]="submitDisabled()"
    [attr.disabled]="submitDisabled() ? '' : null"
    (click)="onSubmit()"
  >
    {{ label() }}
  </button>
}
